import { Price } from '@spartacus/core';
import { CustomB2BUnit, CustomUser } from './user.models';
import { OrderHistoryList } from '@spartacus/order/root';
import { CustomProduct } from './product.model';
import { CustomProductAddress } from './addresses.model';

export enum CUSTOM_ORDER_TYPE {
  ZPRE = 'ZPRE',
}

export interface CustomOrderHistory extends OrderHistoryList {
  orders?: OrderItem[];
}

export interface CustomQuotesList {
  quotes?: OrderItem[];
}

export interface OrderItem {
  code?: string;
  consignments?: any[];
  directOrder?: boolean;
  entries?: Entry[];
  guid?: string;
  invoices?: any[];
  orderType?: string;
  purchaseOrderNumber?: string;
  sapSystemType?: string;
  seasonId?: string;
  shipToId?: string;
  shipToName?: string;
  soldToId?: string;
  soldToName?: string;
  soldToPostalCode?: string;
  status?: string;
  statusDisplay?: string;
  sumDoses?: number;
  sumQuantity?: number;
  total?: Price;
  tracking?: any[];
  user?: CustomUser;
  state?: string;
  cartType?: string;
  billingAddress?: CustomProductAddress;
  shippingAddress?: CustomProductAddress;
  totalPrice?: Price;
  totalTax?: Price;
}

export interface ReservationItem extends OrderItem {
  user?: CustomUser;
  associatedUnit?: CustomB2BUnit;
}

export interface Entry {
  basePrice?: Price;
  cancellableQuantity?: number;
  configurationInfos?: any[];
  confirmedDate?: string;
  confirmedQuantity?: string;
  deliverySchedulesNumber?: number;
  dzConfirmedQuantity?: string;
  entryNumber?: number;
  estimatedDeliveryDate?: string;
  freightProduct?: boolean;
  product?: CustomProduct;
  quantity?: number;
  quantityStatus?: string;
  returnableQuantity?: number;
  sapEntryNumber?: number;
  statusSummaryList?: any[];
  totalPrice?: Price;
  wholesalerProduct?: boolean;
}

export enum RESERVATION_ACTION_TYPE {
  APPROVE = 'approve',
  REJECT = 'reject',
  AKNOWLEDGE = 'aknowledge',
  CANCEL = 'cancel',
}
